// if using SVG and you require older browser support uncomment below
require('svg4everybody')();

// Component Registration
var componentRegistry = require('./lib/componentRegistry');

componentRegistry.registerComponent('loadMore', require('./modules/loadMore'));
componentRegistry.registerComponent('vidQuote', require('./modules/vidQuote'));
componentRegistry.registerComponent('mobileNav', require('./modules/mobileNav'));
componentRegistry.registerComponent('myCourses', require('./myCourses'));
componentRegistry.registerComponent('windowPopup', require('./modules/windowPopup'));
componentRegistry.initComponents();

// open external links in new window
require('./lib/openExternalLinksNewWindow')();



//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = 0
// module chunks = 0